import TextField from "@mui/material/TextField";

import { MainButton } from "../../components/MainButton";
import { COLORS } from "../../utils/colors";
import { ICONS } from "../../utils/icons";

export const SmartContract = ({ event }) => {
  return (
    <>
      <div style={{ height: "20px" }} />
      <div className="standard-container" style={{ marginBottom: "20px" }}>
        <h2>Organization Smart Contract</h2>
        <p id="subTitle" style={{ marginBottom: "20px" }}>
          Allow your members to buy memberships on the blockchain.
        </p>
        <div style={{ height: "30px" }} />
        <div className="container-column">
          <p
            id="subtitleBlack"
            style={{
              margin: "0px 0px 3px",
            }}
          >
            Smart contract address
          </p>
          <TextField
            fullWidth
            disabled
            size="small"
            placeholder="not set"
            value={event?.smart_contract_address}
            sx={{
              width: "500px",
              "& label": {
                paddingLeft: (theme) => theme.spacing(1),
              },
              "& fieldset": {
                borderRadius: "6px",
                border: `2px solid #f0f1f5`,
                transition: ".2s ease-in-out all",
              },
              "& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline":
                {
                  borderColor: "#f0f1f5",
                },
              "& .MuiOutlinedInput-input:hover": {
                cursor: "not-allowed",
              },
            }}
          />
          <div style={{ height: "15px" }} />
          <MainButton
            text={"Open on blockchain explorer"}
            color={COLORS.black}
            hoverColor={COLORS.black}
            textColor={COLORS.white}
            borderColor={COLORS.black}
            shadowColor={COLORS.mainAccent}
            textHoverColor={COLORS.lightGrey}
            onClickAction={() =>
              window.open(
                `${process.env.REACT_APP_POLYGONSCAN}/address/${event?.smart_contract_address}`,
                "_blank"
              )
            }
            width={"fit-content"}
          >
            {ICONS.external20}
          </MainButton>
        </div>
      </div>
    </>
  );
};
